module.exports = __webpack_public_path__ + "img/blog1.1ef4137e.jpg";